import { supabase } from '../db/client'

export function retrievePublicUrl(bucket: string, filePath: string, fileName: string) {
  const { data } = supabase.storage.from(bucket).getPublicUrl(`${filePath}/${fileName}`)
  return data
}
